// Utility to get the current domain (origin) in both browser and SSR/static environments

/**
 * Returns the current domain (origin) as a string.
 * - In the browser, uses window.location.origin
 * - In SSR/static, uses REACT_APP_MARKETPLACE_ROOT_URL env variable
 * - Returns empty string if neither is available
 */
export function getDomain() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  // For SSR/static builds, use env variable (must be injected at build time)
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_MARKETPLACE_ROOT_URL) {
    return process.env.REACT_APP_MARKETPLACE_ROOT_URL.replace(/\/$/, '');
  }
  return '';
}

export default getDomain;
